<template>
    <div class="position-box delegateList">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('jghy.cclb')}}</div>
        </div>
         <ul class="type-box entrust">
            <li class="type" @click.stop="down">
                <div class="text">{{curCurrency}}</div>
                <img class="down" src="@/assets/down.png" alt="">

            </li>
            <li class="type" @click.stop="down2">
                <div class="text">{{wtlx}}</div>
                <img class="down" src="@/assets/down.png" alt="">
            </li>
        </ul>
        <div class="scroll"  @scroll="listenScroll">
            <ul class="cont-box">
                <li class="list" v-for="(item,index) in wetTuoData" :key="item.id">
                    <div class="list-head">
                        <div class="buy"  v-if="item.mark == 1">{{$t('kxt.mr')}}</div>
                        <div class="buy sell"  v-if="item.mark == 2">{{$t('kxt.mc')}}</div>
                        <div class="type">{{item.currency}} <span>/USDT</span></div>
                        <div class="date">{{item.time | subStr1}}</div>
                        <div class="time">{{item.time | subStr2}}</div>
                        <div class="status" v-if="item.status == 2">{{$t('hyjy.ycd')}}</div>
                        <div class="status" v-else-if="item.status == 1">{{$t('hyjy.ywc')}}</div>
                        <div class="btn-cancle" v-else @click="cancelOrder(index,item.id)">{{$t('hyjy.cd')}}</div>
                    </div>
                    <div class="list-body">
                        <div class="list-item">
                            <div class="list-item-left">
                                <div><span>{{$t('hyjy.wtzl')}}</span> {{item.amount}}</div>
                            </div>
                            <div class="list-item-right">
                                <div><span>{{$t('hyjy.wtjg')}}</span> {{item.price}}</div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- 暂无数据 -->
            <div class="null-box" v-show="isNoData">
                <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                <p class="text">{{$t('zwsj.title')}}</p>
            </div>
            <div class="mask" v-show="isDown" @click="down"></div>
            <div class="mask" v-show="isDown2" @click="down2"></div>
            <ul class="select-box" v-show="isDown">
                <li class="select" v-for="(item,index) in currencyData" :key="index" @click.stop="select(item.name)">{{item.name}}</li>
            </ul>
            <ul class="select-box select-box2" v-show="isDown2">
                <li class="select" data-wt="12" @click.stop="select2(12,$t('hyjy.lswt'))">{{$t('hyjy.lswt')}}</li>
                <li class="select" data-wt="13" @click.stop="select2(13,ycd)">{{ycd}}</li>
            </ul>
            <!-- 返回顶部 -->
            <img id="goTop" v-if="theme" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/theme/goTop_white.png" alt="">
            <img id="goTop" v-else class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/goTop.png" alt="">
        </div>
    </div>
</template>
<script>
let vm = null;
export default {
    name: 'delegateList',
    data () {
        return {
            isNoData: false,
            isGoTOP: false,
            currency: 'BTC',
            curCurrency: '',
            wtlx: this.$t('hyjy.lswt'),
            tradeIdx: '',
            tabIdx: 0,
            wt: 12,//合约委托
            type: 2,
            currencyData:[],
            wetTuoData: [],
            curDataLength: 10,
            page: 1,
            limit: 10,
            mai: '',
            sell: '',
            wtzl: '',
            wtjg: '',
            ycd: '',
            ywc: '',
            cd: '',
            theme: false,
            isDown: false,
            isDown2: false
        }
    },
    beforeCreate(){
      vm = this;
    },
    created(){
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.tradeIdx =  this.$route.query.tradeIdx;
        this.mai = this.$t('hyjy.mai');
        this.sell = this.$t('hyjy.sell');;
        this.wtzl = this.$t('hyjy.wtzl');;
        this.wtjg = this.$t('hyjy.wtjg');;
        this.ywc = this.$t('hyjy.ywc');;
        this.ycd = this.$t('hyjy.ycd');;
        this.cd = this.$t('hyjy.cd');;
    },
    mounted() {
      this.getCurrency();//获取币种
    },
    methods: {
       back(){
         this.$router.push({ path: '/perpetualContract', query: { tradeIdx: this.tradeIdx } })
       },
       down(){
        this.isDown = !this.isDown;
        this.isDown2 = false;
       },
       down2(){
         this.isDown = false;
         this.isDown2 = !this.isDown2;
       },
       select(curText){
          this.page = 1;
          this.wetTuoData = [];
          this.currency = this.curCurrency =curText;
          this.getWeiTuo();
          this.isDown = false;
       },
       select2(type,text){
          this.page = 1;
          this.wetTuoData = [];
          this.wt = type;
          this.wtlx = text;
          this.getWeiTuo();
          this.isDown2 = false;
       },
       getCurrency(){
          let that = this;
          let params = {
              currency: that.currency,
              type: 2
          }
          this.$ajax.get('/web/getCurrencyPriceAndIncrease',{params}).then((res) => {
              let resData = res.data.data;
              that.currencyData = resData.price;
              that.curCurrency = that.currency = resData.price[0].name;
              that.getWeiTuo();//获取委托
          }).catch(function(err){
              console.log(err)
          })
      },
      getWeiTuo(){
          let that = this;
          let params = {
              currency: that.currency,
              type: that.type,
              wt: that.wt,
              limit: that.limit,
              page: that.page
          }
          this.$ajax.get('/web/getWeiTuo',{params}).then((res) => {
              let resData = res.data.data;
              if(resData.list.length > 0){
                  that.wetTuoData = that.wetTuoData.concat(resData.list);
                  that.curDataLength = resData.list.length;
              }else{
                  that.curDataLength = resData.list.length;
              }
              if(that.wetTuoData.length > 0){
                  that.isNoData = false;
              }else{
                  that.isNoData = true;
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      listenScroll(e) {  //监听滚动
          let ele = e.srcElement ? e.srcElement : e.target;
          if(ele.scrollTop > 200){
              this.isGoTOP = true
          }else{
              this.isGoTOP = false
          }
          if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
            if(this.curDataLength >= this.limit){
              this.page ++;
              this.getWeiTuo();
            }
          }
      },
      qbcd(){//全部撤单
        this.$ajax.post('/web/assetRecharge',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(resData.message);
                window.location.reload;
            }else{
                this.$toast.center(resData.message);
                return;
            }
          }).catch(function(err){
              console.log(err)
          })
      },
      cancelOrder(idx,id){//撤单
          let that = this;
          let params = {
            id: id
          }
          that.wetTuoData.splice(idx,1);
          this.$ajax.post('/web/orderCancel',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(resData.message);
                that.wetTuoData();
            }else{
                this.$toast.center(resData.message);
                return;
            }
          }).catch(function(err){
              console.log(err)
          })
      },
      goTop(){
        $('.scroll').animate({scrollTop:'0px'},'slow');
      }
    },
    filters:{
      subStr1(val){
          return val.substring(5, 10);
      },
      subStr2(val){
          return val.substring(11, 19);
      }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .type-box{
        position: fixed;
        top: 1.6rem;
        z-index: 99;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        padding: .42rem;
        background: #fff;
        box-sizing: border-box;
    }
    .type-box .type{
        position: relative;
        display: flex;
        justify-content: center;
        width: 50%;
        align-items: center;
        text-align: center;
    }
    .type-box .type .text{
      font-size: .42rem;
    }
    .type-box .type .down{
        margin-left: .18rem;
        width: .3rem;
        height: .24rem;
    }
    .select-box{
        position: fixed;
        bottom: 0;
        left: -1px;
        right: 0;
        z-index: 1000;
        height: auto;
        max-height: 10rem;
        background: #fff;
        overflow-y: scroll;
    }
    .select-box .select{
        padding: .4rem 0;
        color: #7f7f7f;
        font-size: .36rem;
        border-bottom: 1px solid #dcdcdc;
        text-align: center;
    }
    .select-box .select:last-child{
        border-bottom: none;
    }
    .scroll{
        position: absolute;
        top: 3rem;
        width: 100%;
        bottom: 0;
        height: auto;
        background: #fff;
        overflow-y: auto;
    }
    .cont-box{
        padding: 0 .36rem .6rem .48rem;
    }
    .cont-box .list{
        margin-top: .6rem;
        background: #fff;
    }
    .cont-box .list .list-head{
        display: flex;
        align-items: center;
    }
    .cont-box .list .buy{
        padding: 1px .12rem;
        color: #fff;
        font-size: .36rem;
        border-radius: .18rem;
        background: #00c483;
    }
    .cont-box .list .sell{
        background: #d85656;
    }
    .cont-box .list .type{
        padding: 0 .3rem 0 .24rem;
        color: #000;
        font-weight: bold;
    }
    .cont-box .list .type span{
        color: #b5b5b5;
        font-size: .4rem;
        font-weight: normal;
    }
    .cont-box .list .date{
        color: #b5b5b5;
    }
    .cont-box .list .time{
        flex: 1;
        padding-left: .3rem;
        color: #b5b5b5;
    }
    .cont-box .list .btn-cancle{
        padding: .12rem .24rem;
        color: #218adc;
        font-size: .36rem;
        border: 1px solid #218adc;
        border-radius: .12rem;
    }
    .cont-box .list .status{
        color: #b5b5b5;
    }
    .cont-box .list .list-body .list-item{
        margin-top: .3rem;
        color: #7f7f7f;
    }
    .cont-box .list .list-body .list-item-right{
        flex: 1;
        margin-top: .3rem;
    }
    .cont-box .list .list-body .t2{
        margin-top: .3rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/delegateList.vue